/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetNetworkIcpRequest = { domain: string };

export const GetNetworkIcpRequest$zodSchema: z.ZodType<GetNetworkIcpRequest> = z
  .object({
    domain: z.string().describe("需要查询的域名或URL"),
  });

export type GetNetworkIcpNotFoundDetails = {};

export const GetNetworkIcpNotFoundDetails$zodSchema: z.ZodType<
  GetNetworkIcpNotFoundDetails
> = z.object({});

/**
 * 未查询到备案信息。该域名可能没有在工信部备案，或者是我们查询的上游接口暂时没有收录。
 */
export type GetNetworkIcpNotFoundResponseBody = {
  code?: string | undefined;
  details?: GetNetworkIcpNotFoundDetails | undefined;
  message?: string | undefined;
};

export const GetNetworkIcpNotFoundResponseBody$zodSchema: z.ZodType<
  GetNetworkIcpNotFoundResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetNetworkIcpNotFoundDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe(
  "未查询到备案信息。该域名可能没有在工信部备案，或者是我们查询的上游接口暂时没有收录。",
);

export type GetNetworkIcpBadRequestDetails = {};

export const GetNetworkIcpBadRequestDetails$zodSchema: z.ZodType<
  GetNetworkIcpBadRequestDetails
> = z.object({});

/**
 * 请求参数无效。请检查 `domain` 参数是否提供且格式正确。
 */
export type GetNetworkIcpBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetNetworkIcpBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetNetworkIcpBadRequestResponseBody$zodSchema: z.ZodType<
  GetNetworkIcpBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetNetworkIcpBadRequestDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe("请求参数无效。请检查 `domain` 参数是否提供且格式正确。");

/**
 * 查询成功！返回该域名的ICP备案详情。
 */
export type GetNetworkIcpResponseBody = {
  code?: string | undefined;
  domain?: string | undefined;
  msg?: string | undefined;
  natureName?: string | undefined;
  serviceLicence?: string | undefined;
  unitName?: string | undefined;
};

export const GetNetworkIcpResponseBody$zodSchema: z.ZodType<
  GetNetworkIcpResponseBody
> = z.object({
  code: z.string().optional(),
  domain: z.string().optional(),
  msg: z.string().optional(),
  natureName: z.string().optional(),
  serviceLicence: z.string().optional(),
  unitName: z.string().optional(),
}).describe("查询成功！返回该域名的ICP备案详情。");

export type GetNetworkIcpResponse =
  | GetNetworkIcpResponseBody
  | GetNetworkIcpBadRequestResponseBody
  | GetNetworkIcpNotFoundResponseBody;

export const GetNetworkIcpResponse$zodSchema: z.ZodType<GetNetworkIcpResponse> =
  z.union([
    z.lazy(() => GetNetworkIcpResponseBody$zodSchema),
    z.lazy(() => GetNetworkIcpBadRequestResponseBody$zodSchema),
    z.lazy(() => GetNetworkIcpNotFoundResponseBody$zodSchema),
  ]);
